import type { SorterResult } from 'antd/es/table/interface';

export const getActiveSorter = <T>(
  sorter: SorterResult<T> | SorterResult<T>[]
): SorterResult<T> | null => {
  if (Array.isArray(sorter)) {
    const withOrder = sorter.find(s => s.order);
    return withOrder ?? null;
  }

  return sorter.order ? sorter : null;
};
